import { Card, CircularProgress, Backdrop, Icon, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

function WhatsAppNumberContactsPage() {
  const pageTitle = "WhatsApp - Contacts";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { ref } = useParams();
  const statusDialog = useAwaitDialog();

  const [showLoading, setShowLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [contacts, setContacts] = useState([]);

  const tableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Phone Number", accessor: "phone_number", align: "left" },
    { Header: "WhatsApp ID", accessor: "wa_id", align: "left" },
    { Header: "Display Name", accessor: "wa_display_name", align: "left" },
  ];

  const buildRows = (data) => {
    const rows = [];

    data.map((row) => {
      rows.push({
        name: row.name || "-",
        phone_number: row.phone_number || "-",
        wa_id: row.wa_id || "-",
        wa_display_name: row.wa_display_name || "-",
      });

      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);

      await axios
        .get(`/portal/wacc/businesses/numbers/${ref}/contacts.json`)
        .then((result) => {
          setShowLoading(false);

          if (result.data.status === "success") {
            setContacts(buildRows(result.data.data.contacts));
            setPageLoaded(true);
          } else {
            statusDialog.show(result.data.data.message, "error", "Request Failed");
          }
        })
        .catch(async () => {
          setShowLoading(false);

          await statusDialog.show(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`,
            "error",
            "Request Failed"
          );
        });
    };

    fetchData();
  }, [ref]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox mt={1} mb={5}>
        <MDBox mb={2} display="flex" justifyContent="space-between">
          <Button
            color="dark"
            size="small"
            startIcon={<Icon>west</Icon>}
            onClick={() => navigate(`/wacc/businesses/number/${ref}`)}
          >
            Back
          </Button>
          <MDBox display="flex" gap={1}>
            <MDButton
              variant="contained"
              color="dark"
              startIcon={<Icon>download</Icon>}
              onClick={() => {
                alert("Coming soon");
              }}
              size="small"
            >
              Export Contacts
            </MDButton>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <Card sx={{ height: "100%", marginTop: "0px" }}>
            <MDBox>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                  <MDTypography variant="h6" fontWeight="medium">
                    Contacts
                  </MDTypography>
                </MDBox>
              </MDBox>

              <MDBox p={0}>
                <DataTable
                  table={{
                    columns: tableColumns,
                    rows: contacts,
                  }}
                  isSorted
                  entriesPerPage={false}
                  showTotalEntries
                  buttons
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        )}
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default WhatsAppNumberContactsPage;
